import {hidePageLoad, showPageLoad} from "../../../modules/actions";
import {customAxios as axios, getToken} from "../../../request";
import { notification } from 'antd'
import {
    applyPackageUrl,
    getDestinationsUrl,
    getPackagesUrl,
    getUatTokenUrl,
    fetchPackageDataUrl,
    getBearerTokenUrl,
    getPackageListUrl,
    payPaymentUrl, updateEsimPaymentUrl, getSingleEsimUrl
} from '../api'
import { counsellorBonusListUrl } from '../../CounsellorBonus/api'

export const getUatTokenFxn = valData => async dispatch => {
    dispatch(showPageLoad())
    let { data } = await axios.post(getUatTokenUrl(), valData, getToken())
    dispatch(hidePageLoad())
    return data
}

export const getDestinationsFxn = async (valData) => {
    let { data } = await axios.post(getDestinationsUrl(), valData, getToken())
    return data
}

/*export const getDestinationsFxn = valData => async dispatch => {
    dispatch(showPageLoad())
    let { data } = await axios.post(getDestinationsUrl(), valData)
    dispatch(hidePageLoad())
    return data
}*/

export const getPackagesFxn = valData => async dispatch => {
    // dispatch(showPageLoad())
    let { data } = await axios.post(getPackagesUrl(), valData, getToken())
    // dispatch(hidePageLoad())
    return data
}

export const applyPackagesFxn = valData => async dispatch => {
    dispatch(showPageLoad())
    let { data } = await axios.post(applyPackageUrl(), valData, getToken())
    dispatch(hidePageLoad())
    return data
}

export const fetchPackageDataFxn = valData => async dispatch => {
    dispatch(showPageLoad())
    let { data } = await axios.post(fetchPackageDataUrl(), valData, getToken())
    dispatch(hidePageLoad())
    return data
}

export const getBearerTokenFxn = (valData) => async (dispatch) => {
    dispatch(showPageLoad())
    let config = {
        params: { ...valData },
        ...await getToken()
    }
    let { data } = await axios.get(getBearerTokenUrl(), config)
    dispatch(hidePageLoad())
    return data
}

export const getPackageListFxn = (filters) => async (dispatch) => {
    dispatch(showPageLoad())
    let config = {
        params: { ...filters },
        ...await getToken()
    }
    let { data } = await axios.get(getPackageListUrl(), config)
    dispatch(hidePageLoad())
    return data.data

}

export const payPaymentFxn = valData => async dispatch => {
    dispatch(showPageLoad())
    let { data } = await axios.post(payPaymentUrl(), valData, getToken())
    dispatch(hidePageLoad())
    return data
}


export const updateEsimPaymentFxn = valData => async dispatch => {
    dispatch(showPageLoad())
    let { data } = await axios.post(updateEsimPaymentUrl(), valData, getToken())
    dispatch(hidePageLoad())
    return data
}
export const getSingleEsimFxn = valData => async dispatch => {
    dispatch(showPageLoad())
    let { data } = await axios.post(getSingleEsimUrl(), valData, getToken())
    dispatch(hidePageLoad())
    return data
}
